import { useTranslation } from 'react-i18next';
import Page from '@/components/Page';
import { Button } from '@mantine/core';
import classes from './personal.module.css';
import LogoPageImage from '../../assets/images/logo-page.svg?react'; // eslint-disable-line import/no-unresolved

const Personal = () => {
  const { t } = useTranslation();

  return (
    <Page
      isFull
    >
      <div className={classes.contents}>
        <section className={classes.body}>
          <div className={classes.head}>{t('pages.personal.title')}</div>
          <div className={classes.logo}><LogoPageImage /></div>
          <div className={classes.actions}>
            <Button
              component="a"
              href="https://portal.roeto.co.il/polaris"
              target="_blank"
              variant="filled"
            >
              {t('pages.personal.actions.clients.title')}
            </Button>

            <Button
              component="a"
              href="https://portal.roeto.co.il/shoshanapolaris/"
              target="_blank"
              variant="outline"
            >
              {t('pages.personal.actions.shoshana.title')}
            </Button>

            <Button
              component="a"
              href="https://portal.roeto.co.il/it/"
              target="_blank"
              variant="outline"
            >
              {t('pages.personal.actions.itchik.title')}
            </Button>

            <Button
              component="a"
              href="https://portal.roeto.co.il/guy/"
              target="_blank"
              variant="outline"
            >
              {t('pages.personal.actions.guy.title')}
            </Button>
          </div>
        </section>
        <section className={classes.hero}></section>
      </div>
    </Page>
  );
};

export default Personal;
